/**
 * LD Product Accordions - Accordion functionality for product page
 */

class LDProductAccordions {
  constructor() {
    this.init();
  }

  /**
   * Toggle accordion state
   */
  toggleAccordion(button) {
    const accordion = button.closest('.ld-product-page__accordion');
    const content = accordion.querySelector('.ld-product-page__accordion-content');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Toggle state
    button.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('data-expanded', !isExpanded);
    
    // Toggle content visibility using CSS classes
    if (isExpanded) {
      content.classList.remove('expanded');
    } else {
      content.classList.add('expanded');
    }
  }

  /**
   * Initialize accordion functionality
   */
  initAccordions() {
    const accordionToggles = document.querySelectorAll('.ld-product-page__accordion-toggle');
    
    if (accordionToggles.length === 0) {
      console.warn('LD Product Accordions: No accordion toggles found');
      return;
    }
    
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(toggle);
      });
    });
  }

  init() {
    this.initAccordions();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Small delay to ensure all elements are rendered
  setTimeout(() => {
    new LDProductAccordions();
  }, 100);
});
